import React from "react";

class Scale extends React.Component {
    constructor(props) {
        super(props);
        const colour = this.props.color;
        var initial = this.props.num;
        this.state = {
            style: {
                width: "80%",
                height: "50px",
                display: "block",
                color: colour
            },
            val: initial,
            ident: "percent-scale"
        }
        if ((navigator.userAgent.toLowerCase().indexOf("chrome") > -1 || navigator.userAgent.toLowerCase().indexOf("opera") > -1) && navigator.userAgent.toLowerCase().indexOf("edge") === -1) {
            this.state.style["background"] = colour;
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.num !== this.state.val) {
            this.setState({val: nextProps.num});
        }
    }


    render() {
        const colour = this.props.color;
        return (
            <div className={this.state.ident}>
                <p>Impact</p>
                <aside>{this.state.val}%</aside>
                <progress style={this.state.style} value={this.state.val} max="100"></progress>
            </div>
        )
    }
}

export default Scale;


// WEBPACK FOOTER //
// ./src/scale.js